import { ALL_LOCATIONS, PROVINCE_BY_SLUG } from '@/app/lib/constants'

/**
 * ¿Este `pathname` (URL visible) es una home?
 *
 * Dos casos: la home general `/entradas/` y la home localizada
 * `/entradas/{provincia}/`. La segunda llega por un `rewrite` de `src/proxy.ts`
 * a `home-localizado/[location]` que NO cambia la URL visible, así que
 * `usePathname` devuelve `/entradas/madrid/`, no la ruta interna: hay que
 * reconocerla con la misma regla que el proxy (un único segmento que sea un
 * slug de provincia, salvo `todos`).
 *
 * Lo usa el header para no mostrar su buscador mientras se ve el de la
 * SearchBand de la home.
 */
export function isHomePathname(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean)
  if (segments[0] !== 'entradas') return false
  if (segments.length === 1) return true
  if (segments.length !== 2) return false
  const [, slug = ''] = segments
  return slug !== ALL_LOCATIONS && PROVINCE_BY_SLUG.has(slug)
}
